var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCriacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 9.9H10.8V8.1H3.6V9.9ZM3.6 12.6H10.8V10.8H3.6V12.6ZM3.6 15.3H8.1V13.5H3.6V15.3ZM1.8 18C1.305 18 0.88125 17.8238 0.52875 17.4713C0.17625 17.1188 0 16.695 0 16.2V1.8C0 1.305 0.17625 0.88125 0.52875 0.52875C0.88125 0.17625 1.305 0 1.8 0H9L14.4 5.4V16.2C14.4 16.695 14.2237 17.1188 13.8712 17.4713C13.5187 17.8238 13.095 18 12.6 18H1.8ZM8.1 6.3V1.8H1.8V16.2H12.6V6.3H8.1Z",
    fill: "#865829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCriacao);
export default __webpack_public_path__ + "static/media/criacao.c7ca332f4f5d1318eba14b634b39acec.svg";
export { ForwardRef as ReactComponent };